<template>
  <div class="login-view">
    <div class="login-view__inner">
      <div class="login-view__masthead">
        <p class="eyebrow">Pressbox Access</p>
        <h1 class="login-view__headline">Credentials,<br /><em>please.</em></h1>
        <div class="login-view__rule" aria-hidden="true"></div>
        <p class="login-view__dek">
          The morning edition is waiting. Sign in to access tonight's projections, simulated box
          scores, and the day's edge sheet.
        </p>
      </div>

      <div class="login-view__card">
        <div class="login-view__card-corner login-view__card-corner--tl" aria-hidden="true">♦</div>
        <div class="login-view__card-corner login-view__card-corner--tr" aria-hidden="true">♦</div>
        <div class="login-view__card-corner login-view__card-corner--bl" aria-hidden="true">♦</div>
        <div class="login-view__card-corner login-view__card-corner--br" aria-hidden="true">♦</div>
        <LoginForm />
      </div>

      <p class="login-view__footer">
        <span>No account?</span>
        <a href="mailto:subscriptions@homerundata.com" class="link-ink">Apply for the press list</a>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import LoginForm from '@/components/features/auth/LoginForm.vue'
</script>

<style scoped>
.login-view {
  min-height: calc(100vh - 4.75rem);
  margin-top: 4.75rem;
  padding: 3.5rem 1.5rem 5rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
}

.login-view::before {
  content: '';
  position: absolute;
  top: 5rem;
  left: 50%;
  width: 720px;
  height: 720px;
  transform: translateX(-50%);
  border: var(--rule-thin) solid var(--ink-10);
  border-radius: 50%;
  pointer-events: none;
}

.login-view__inner {
  width: 100%;
  max-width: 520px;
  position: relative;
}

.login-view__masthead {
  text-align: center;
  margin-bottom: 2.5rem;
}

.login-view__masthead .eyebrow {
  margin-bottom: 1rem;
}

.login-view__headline {
  font-family: var(--font-display);
  font-variation-settings:
    'opsz' 144,
    'SOFT' 40,
    'wght' 700;
  font-size: clamp(2.5rem, 6vw, 4.25rem);
  line-height: 0.95;
  letter-spacing: -0.03em;
  color: var(--ink);
  margin-bottom: 1.25rem;
}

.login-view__headline em {
  font-style: italic;
  color: var(--ox);
  font-variation-settings:
    'opsz' 144,
    'SOFT' 100,
    'wght' 500;
}

.login-view__rule {
  width: 72px;
  height: 3px;
  border-top: 1px solid var(--ink);
  border-bottom: 1px solid var(--ink);
  margin: 0 auto 1.25rem;
}

.login-view__dek {
  font-family: var(--font-editorial);
  font-size: 1rem;
  line-height: 1.55;
  color: var(--ink-medium);
  max-width: 38ch;
  margin: 0 auto;
}

.login-view__card {
  position: relative;
  background: var(--paper);
  border: var(--rule-thin) solid var(--ink);
  padding: 2.75rem 2.25rem 2.25rem;
  box-shadow: 6px 6px 0 var(--ink);
}

.login-view__card-corner {
  position: absolute;
  font-size: 0.85rem;
  color: var(--ox);
}
.login-view__card-corner--tl {
  top: 0.6rem;
  left: 0.75rem;
}
.login-view__card-corner--tr {
  top: 0.6rem;
  right: 0.75rem;
}
.login-view__card-corner--bl {
  bottom: 0.6rem;
  left: 0.75rem;
}
.login-view__card-corner--br {
  bottom: 0.6rem;
  right: 0.75rem;
}

.login-view__footer {
  margin-top: 2rem;
  text-align: center;
  font-family: var(--font-editorial);
  font-style: italic;
  font-size: 0.95rem;
  color: var(--ink-faint);
}

.login-view__footer span {
  margin-right: 0.5rem;
}
</style>
